module.exports = __webpack_public_path__ + "static/media/hb_bg2.516fe474.png";